import { type ReactElement } from 'react'
import { type UserCheckSuccess } from '@terros/common'
import { Link } from '@tanstack/react-router'
import { AppShell, Card, Group, Stack, Text, Title } from '@mantine/core'
import { showNewMessage } from '@intercom/messenger-js-sdk'
import { useTranslation } from '@front/model'
import { ThemeButton } from '../ThemeButton'
import { TButton } from '../buttons'
import { UserSection } from './UserSection'
import { ButtonSignOut } from './signout'
import { Header, useHeaderHeight } from './Header'

type Props = {
  result: Extract<UserCheckSuccess, { canAccess: false }>
}

export const ArchivedShell = ({ result }: Props): ReactElement => {
  const headerHeight = useHeaderHeight()
  const { t } = useTranslation()

  return (
    <AppShell header={{ height: headerHeight }} padding={0}>
      <Header>
        <Group>
          <ThemeButton />
          <UserSection />
        </Group>
      </Header>
      <AppShell.Main className='flex flex-col items-center justify-center p-4'>
        <Stack align='center' maw={500}>
          <Title>{result.reason}</Title>
          <Card bg='brand' className='flex items-center justify-center' shadow='md'>
            <Stack>
              <Text c='white'>{result.label}</Text>
              {result.link && <Link to={result.link}>{result.link}</Link>}
              <ButtonSignOut />
            </Stack>
          </Card>
          {result.allowReachSupport && (
            <TButton
              icon='support'
              variant='accent'
              onClick={() => {
                showNewMessage('')
              }}
            >
              {t('Contact Support')}
            </TButton>
          )}
        </Stack>
      </AppShell.Main>
    </AppShell>
  )
}
